import ApiService from '@/services/apiService';
import { mapState } from 'vuex';
export default {
  name: 'CoreDtwinFinder',
  props: {
    value: {
      type: [Number, Boolean],
      default: () => null
    },
    appendIcon: {
      type: String,
      required: false,
      default: null
    },
    label: {
      type: String,
      default: () => ''
    },
    placeholder: {
      type: String,
      default: () => ''
    },
    userId: {
      type: String,
      default: () => null
    },
    parentId: {
      type: Number,
      default: () => null
    },
    sameTenant: {
      type: Boolean,
      default: () => false
    },
    tenantId: {
      type: Number,
      default: () => null
    },
    tagFilter: {
      type: Array,
      default: () => []
    },
    objectFilter: {
      type: Function,
      default: null
    },
    required: {
      type: Boolean,
      default: () => false
    },
    requiredErrorText: {
      type: String,
      default: null,
      required: false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    dense: {
      type: Boolean,
      default: () => false
    },
    // eslint-disable-next-line vue/require-prop-types
    hideDetails: {
      required: false,
      default: () => false
    },
    loadFullDtwinData: {
      type: Boolean,
      required: false,
      default: () => false
    },
    skipDisabledCheckForFetchOfSelectedTwin: {
      type: Boolean,
      required: false,
      default: () => false
    },
    skipTenantCheckForFetchOfSelectedTwin: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data() {
    return {
      treeMenu: false,
      treeMenuPosition: {},
      digitalTwin: null,
      isLoading: false,
      rules: [() => !!this.digitalTwin || this.requiredErrorText || this.$i18n_t('IS.FM.AccessMgmt.accessObjectReq')],
      noRules: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    readonlyName() {
      if (this.digitalTwin) {
        return `${this.digitalTwin.title} (${this.$i18n_t('Common.id')}: ${this.digitalTwin.id})`;
      }
      return this.label || this.$i18n_t('Common.digitalTwins.searchPlaceholder');
    }
  },
  watch: {
    value() {
      this.fetch();
    },
    disabled(newVal) {
      if (!newVal) {
        this.fetch();
      }
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    doOpenTree(e) {
      e.preventDefault();
      if (!this.disabled) {
        this.treeMenuPosition = {
          x: e.clientX,
          y: e.clientY
        };
        this.treeMenu = true;
      }
    },
    process() {
      this.$emit('input', this.digitalTwin ? parseInt(this.digitalTwin.id) : undefined);
      // for legacy support, or if the whole object is required
      this.$emit('dtwin-selected', this.digitalTwin);
    },
    digitalTwinSelected(e) {
      // NOTE: the tree emits the selection of a twin right after startup
      // this would lead to the tree never really opening, if the already selected twin is emitted again
      // so in that case, ignore the emission as nothing changes
      if (e && this.digitalTwin && e.id === this.digitalTwin.id) {
        return;
      }
      this.digitalTwin = e;
      this.treeMenu = false;
      this.process();
    },
    fetch() {
      if (this.skipDisabledCheckForFetchOfSelectedTwin === false && (this.disabled || !this.value)) {
        return;
      }
      this.loading = true;
      ApiService.digitalTwinGet(this, this.value, !this.loadFullDtwinData).then(dtwin => {
        if (this.skipTenantCheckForFetchOfSelectedTwin !== false || !this.tenantId || dtwin.tenantId === this.tenantId) {
          this.digitalTwin = dtwin;
        } else {
          this.digitalTwin = null;
        }
        this.process();
      }).catch(() => {
        this.loading = false;
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};